import React, { Component } from 'react'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import { reduxForm, Field, formValueSelector } from 'redux-form'
import labelAndInput from '../common/form/labelAndInput'
import textArea from '../common/form/textArea'

import { init } from './boletoAction'



class BoletoFormView extends Component {


    render() {
        
        const { handleSubmit, readOnly } = this.props
        const formatData = (value) => {
            let dateTime = value.split(' ')
            let dtSplit = dateTime[0].split('-')
            return `${dtSplit[2]}/${dtSplit[1]}/${dtSplit[0]} ${dateTime[1]}`
        }

        const formatData2 = (value) => {
            let dateTime = value.split(' ')
            let dtSplit = dateTime[0].split('-')
            return `${dtSplit[0]}-${dtSplit[1]}-${dtSplit[2]}`
        }

        const currencyFormatter = (value)=> {
            if (value === undefined) value = 0
            var valor = value;
            
            valor = valor + '';
            valor = parseInt(valor.replace(/[\D]+/g,''));
            valor = valor + '';
            valor = valor.replace(/([0-9]{2})$/g, ",$1");
          
            if (valor.length > 6) {
              valor = valor.replace(/([0-9]{3}).([0-9]{2}$)/g, ".$1,$2");
            }
          
            return valor
          }

        return (
            <div>

                <form role='form' >

                    <div className="box-body">


                        <Field name='id' component={labelAndInput}
                            label='Id'
                            cols='12 2'
                            placeholder='Id'
                            readOnly={true} />



                        <Field name='carne_id' component={labelAndInput}
                            label='Cod. Carnê'
                            cols='12 2'
                            readOnly={true} />

                        <Field name='dt_cadastro' component={labelAndInput}
                            type='text' cols='12 3'
                            label='Data Cadastro' placeholder='Informe a Agência'
                            readOnly={true}
                            format={formatData} />

                        <Field name='dt_vencimento' component={labelAndInput}
                            label='Data Vencimento'
                            cols='12 2'
                            type='date'
                            readOnly={readOnly} 
                            format={formatData2}/>
                        <Field name='valor' component={labelAndInput}
                            label='Valor'
                            cols='12 2'
                            type='numeric'
                            readOnly={readOnly} 
                            format={currencyFormatter} />

                        <Field name='descricao' component={textArea}
                            cols='12 12'
                            type="textare"
                            label='Descrição'
                            readOnly={readOnly} />

                        <Field name='nome_cliente' component={labelAndInput}
                            cols='12 6'
                            label='Nome Cliente'
                            readOnly={readOnly} />

                        {/* final da primeira linha */}

                        <Field name='cpf_cnpj_cliente' component={labelAndInput}
                            label='CPF'
                            cols='12 2'
                            readOnly={readOnly} />

                        <Field name='endereco' component={labelAndInput}
                            type='text' cols='12 4'
                            label='Endereço'
                            readOnly={readOnly} />

                        <Field name='municipio' component={labelAndInput}
                            type='text' cols='12 3'
                            label='Município'
                            readOnly={readOnly} />

                        <Field name='cep' component={labelAndInput}
                            type='text' cols='12 2'
                            label='CEP'
                            readOnly={readOnly} />

                        <Field name='uf' component={labelAndInput}
                            type='text' cols='12 1'
                            label='Uf'
                            readOnly={readOnly}
                        />

                        {/* final da segunda linha */}
                    </div>
                    <div className="boxfooter">
                        <button type='button' className="btn btn-default"
                            onClick={this.props.init} ><i className="fa fa-ban"></i><span className='space-icon'>Cancelar</span></button>
                    </div>
                </form>
            </div>
        )
    }
}

BoletoFormView = reduxForm({ form: 'boletoFormView', destroyOnUnmount: false })(BoletoFormView)
const selector = formValueSelector('boletoFormView')
const mapStateToProps = state => ({
   
})
const mapDispatchToProps = dispatch => bindActionCreators({ init }, dispatch)
export default connect(mapStateToProps, mapDispatchToProps)(BoletoFormView)



// WEBPACK FOOTER //
// ./src/boleto/boletoFormView.jsx